function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { tokens } from "@tempo/theme";
/**
 * @deprecated this palette is inserted in theme to style non-Deezer re-styled chakra components
 */ const neutralPalette = {
    50: tokens.colors.neutral['00'],
    100: tokens.colors.neutral['20'],
    200: tokens.colors.neutral['40'],
    300: tokens.colors.neutral['60'],
    400: tokens.colors.neutral['80'],
    500: tokens.colors.neutral['100'],
    600: tokens.colors.neutral['120'],
    700: tokens.colors.neutral['140'],
    800: tokens.colors.neutral['170'],
    900: tokens.colors.neutral['200']
};
/**
 * @deprecated this palette is inserted in theme to style non-Deezer re-styled chakra components
 */ const primaryPalette = {
    50: tokens.colors.purple['50'],
    100: tokens.colors.purple['60'],
    200: tokens.colors.purple['70'],
    300: tokens.colors.purple['80'],
    400: tokens.colors.purple['90'],
    500: tokens.colors.purple['100'],
    600: tokens.colors.purple['110'],
    700: tokens.colors.purple['120'],
    800: tokens.colors.purple['130'],
    900: tokens.colors.purple['140']
};
const inputGroupSpacing = {
    'inputGroup.padding.s': `calc(var(--tempo-space-spacing-s) + var(--tempo-space-spacing-xs) + var(--tempo-sizes-icon-m))`,
    // ${tokens.semanticTokens.space['spacing.s']} + ${tokens.semanticTokens.sizes['icon.m']} + ${tokens.semanticTokens.sizes['spacing.xs']})`,
    'inputGroup.padding.m': `calc(var(--tempo-space-spacing-m) + var(--tempo-space-spacing-s) + var(--tempo-sizes-icon-m))`
};
/**
 * @deprecated this palette is used for:
 * - being able to use the old semantic tokens values (deprec as soon as possible)
 * - being able to have compatibility for our main colors with the colorScheme attribute on components styled by Chakra (deprec later)
 */ export const compatibilityTokens = {
    transition: {
        'property.common': 'background-color,border-color,outline-color,color,fill,stroke,opacity,box-shadow,transform',
        'property.colors': 'background-color,border-color,outline-color,color,fill,stroke'
    },
    colors: {
        gray: neutralPalette,
        neutral: neutralPalette,
        primary: primaryPalette,
        purple: primaryPalette
    },
    borderWidths: {
        'border.s': tokens.scales.x0_0625,
        'border.m': tokens.scales.x0_125
    },
    semanticTokens: {
        space: _object_spread({}, inputGroupSpacing),
        sizes: _object_spread({}, inputGroupSpacing),
        fontSizes: {
            'display.l': '5rem',
            'display.m': '4rem',
            'display.s': '3rem',
            'heading.xl': '2.5rem',
            'heading.l': '2rem',
            'heading.brand': '1.5rem',
            'heading.m': '1.25rem',
            'heading.s': '1.125rem',
            'heading.xs': '1rem',
            'body.2xl': '2rem',
            'body.xl': '1rem',
            'body.l': '1rem',
            'body.m': '0.875rem',
            'body.s': '0.875rem',
            'body.xs': '0.75rem',
            'body.2xs': '0.75rem'
        },
        fontWeights: {
            'display.l': 'bold',
            'display.m': 'bold',
            'display.s': 'bold',
            'heading.xl': 'bold',
            'heading.l': 'bold',
            'heading.brand': 'bold',
            'heading.m': 'bold',
            'heading.s': 'bold',
            'heading.xs': 'medium',
            'body.2xl': 'black',
            'body.xl': 'bold',
            'body.l': 'normal',
            'body.m': 'semibold',
            'body.s': 'normal',
            'body.xs': 'semibold',
            'body.2xs': 'normal'
        },
        lineHeights: {
            'display.l': '5rem',
            'display.m': '4rem',
            'display.s': '3rem',
            'heading.xl': '2.5rem',
            'heading.l': '2rem',
            'heading.brand': '1.5rem',
            'heading.m': '1.5rem',
            'heading.s': '1.5rem',
            'heading.xs': '1.25rem',
            'body.2xl': '2.5rem',
            'body.xl': '1.5rem',
            'body.l': '1.5rem',
            'body.m': '1.25rem',
            'body.s': '1.25rem',
            'body.xs': '1rem',
            'body.2xs': '1rem'
        },
        fonts: {
            'display.l': 'heading',
            'display.m': 'heading',
            'display.s': 'heading',
            'heading.xl': 'heading',
            'heading.l': 'heading',
            'heading.brand': 'heading',
            'heading.m': 'body',
            'heading.s': 'body',
            'heading.xs': 'body',
            'body.2xl': 'body',
            'body.xl': 'body',
            'body.l': 'body',
            'body.m': 'body',
            'body.s': 'body',
            'body.xs': 'body',
            'body.2xs': 'body'
        }
    }
};

//# sourceMappingURL=legacy.js.map